import { useProductPrice } from '../../hooks/useProductPrice';
import { CountryCode, CurrencyCode } from '../../types/Locations';

export const ProductPrice = ({
  countryCode,
  currencyCode,
  inMinorUnit,
  prefix,
  price,
  skipConvertCurrency,
  skipTaxCalculation,
  suffix,
}: {
  price: number;
  countryCode?: CountryCode;
  currencyCode?: CurrencyCode;
  inMinorUnit?: boolean;
  skipConvertCurrency?: boolean;
  skipTaxCalculation?: boolean;
  prefix?: string;
  suffix?: string;
}) => {
  const pricing = useProductPrice({
    countryCode,
    currencyCode,
    inMinorUnit,
    prefix,
    price,
    skipConvertCurrency,
    skipTaxCalculation,
    suffix,
  });
  return pricing;
};
